import {v4 as guid} from 'uuid';
import * as requestFromServer from './invoiceOrdersCrud';
import {
  invoiceOrdersConfirmCustomersSlice,
  callTypesConfirmCustomers
} from './invoiceOrdersConfirmCustomersSlice';
import {
  invoiceOrdersEditAndSendSlice,
  callTypesEditAndSend
} from './invoiceOrdersEditAndSendSlice';
import {
  showGlobalMessage
} from '../../_common/actions/globalMessage/showGlobalMessage';
import {messages as M} from '../../../../_metronic/i18n/messages';
import {RequestCancellationManager} from '../../_common/utils/RequestCancellationManager';
import {logUserAction} from '../../../../utils';
import {pages as P} from '../../_common/constants/pages';
import {subjects as S} from '../../_common/constants/subjects';
import {actionTypes as T} from '../../_common/constants/actionTypes';
import {logMessages as L} from '../../_common/constants/logMessages';

const {actions: actionsConfirmCustomers} = invoiceOrdersConfirmCustomersSlice;
const {actions: actionsEditAndSend} = invoiceOrdersEditAndSendSlice;

export const getInvoiceOrdersListIDPrefix = 'getInvoiceOrdersList';

const getInvoiceOrdersList = (storeMethod, callTypes, findInvoiceOrders) => queryParams => dispatch => {
  if (callTypes === callTypesEditAndSend) {
    dispatch(actionsEditAndSend.startCall({callType: callTypes.list}));
  }
  if (callTypes === callTypesConfirmCustomers) {
    dispatch(actionsConfirmCustomers.startCall({callType: callTypes.list}));
  }

  const requestID = `${getInvoiceOrdersListIDPrefix}-${guid()}`;
  const cancellationHandlers = RequestCancellationManager.createCancellationHandlers(requestID);

  return findInvoiceOrders(queryParams, cancellationHandlers)
    .then(response => {
      const {
        errorCode,
        data: {
          totalInvoiceOrdersCount: totalCount,
          pageCount,
          invoiceOrdersList
        }
      } = response.data;
      if (errorCode !== 0) throw new Error();

      dispatch(storeMethod({
        totalCount,
        pageCount,
        entities: invoiceOrdersList
      }));
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = 'Can\'t find invoice orders';

      dispatch(actionsEditAndSend.catchError({
        error,
        callType: callTypes.list
      }));
    })
    .finally(() => {
      RequestCancellationManager.forgetRequest(requestID);
    });
};

export const sendInvoiceOrdersToRivhit = (invoiceOrdersArray, amount, createdDate, agentID) => dispatch => {
  dispatch(actionsEditAndSend.startCall({callType: callTypesEditAndSend.list}));

  return requestFromServer
    .sendInvoiceOrders(invoiceOrdersArray)
    .then(response => {
      const {errorCode, data} = response.data;
      logUserAction(
        P.INVOICE_ORDERS,
        S.INVOICE_ORDER,
        T.EDIT,
        L.INVOICE_ORDERS_SEND_TO_RIVHIT(amount, createdDate, agentID),
        errorCode
      );

      const getSpecialErrorMessage = () => {
        if (data && Array.isArray(data)) {
          const dataWithErrors = data.filter(item => Boolean(item.error));
          if (dataWithErrors.length === data.length) {
            return M.INVOICE_ORDERS_SENDING_FAIL_ALL;
          } else if (dataWithErrors.length < data.length && dataWithErrors.length > 0) {
            return M.INVOICE_ORDERS_SENDING_FAIL_SOME;
          } else return M.OPERATION_FAILED;
        } else return M.OPERATION_FAILED;
      };

      if (errorCode !== 0) {
        const message = errorCode === -4
          ? getSpecialErrorMessage()
          : M.OPERATION_FAILED;
        dispatch(showGlobalMessage(message));
        dispatch(actionsEditAndSend.invoiceOrderStatusEdited({data}));
      } else {
        dispatch(actionsEditAndSend.invoiceOrderStatusEdited({data}));
        dispatch(showGlobalMessage(M.INVOICE_ORDERS_SENDING_SUCCESS));
      }

      return errorCode;
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = 'Can\'t send invoice orders';
      dispatch(actionsEditAndSend.catchError({error, callType: callTypesEditAndSend.list}));
      dispatch(showGlobalMessage(M.OPERATION_FAILED));
    });
};

export const setInvoiceOrderSentManually = (invoiceOrderID, amount, createdDate, agentID) => dispatch => {
  dispatch(actionsEditAndSend.startCall({callType: callTypesEditAndSend.list}));

  return requestFromServer
    .setInvoiceOrderSentManually(invoiceOrderID)
    .then(response => {
      const {errorCode, data} = response.data;
      logUserAction(
        P.INVOICE_ORDERS,
        S.INVOICE_ORDER,
        T.EDIT,
        L.INVOICE_ORDERS_SET_SENT_MANUALLY(amount, createdDate, agentID),
        errorCode
      );
      if (errorCode !== 0) {
        dispatch(showGlobalMessage(M.OPERATION_FAILED));
        throw new Error();
      } else {
        dispatch(actionsEditAndSend.invoiceOrderCanCreateEdited({data}));
        dispatch(showGlobalMessage(M.REQUEST_ENDED_SUCCESSFULLY));
      }

      return errorCode;
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = 'Can\'t set invoice order sent manually!';
      dispatch(actionsEditAndSend.catchError({
        error,
        callType: callTypesEditAndSend.list
      }));
      dispatch(showGlobalMessage(M.OPERATION_FAILED));
    });
};

export const setInvoiceOrderSentManuallyWithoutReduxUpdate = (invoiceOrderID, amount, createdDate, agentID) => dispatch => {
  dispatch(actionsEditAndSend.startCall({callType: callTypesEditAndSend.list}));

  return requestFromServer
    .setInvoiceOrderSentManually(invoiceOrderID)
    .then(response => {
      const {errorCode} = response.data;
      logUserAction(
        P.INVOICE_ORDERS,
        S.INVOICE_ORDER,
        T.EDIT,
        L.INVOICE_ORDERS_SET_SENT_MANUALLY(amount, createdDate, agentID),
        errorCode
      );

      if (errorCode !== 0) throw new Error();

      return errorCode;
    })
    .catch(error => {
      error.clientMessage = 'Can\'t set invoice order sent manually!';
      dispatch(actionsEditAndSend.catchError({
        error,
        callType: callTypesEditAndSend.list
      }));
    });
};

export const getInvoiceOrdersConfirmCustomers = getInvoiceOrdersList(
  actionsConfirmCustomers.invoiceOrdersFetched,
  callTypesConfirmCustomers,
  requestFromServer.findInvoiceOrders(1)
);
export const getNextInvoiceOrdersConfirmCustomers = getInvoiceOrdersList(
  actionsConfirmCustomers.invoiceOrdersAppended,
  callTypesConfirmCustomers,
  requestFromServer.findInvoiceOrders(1)
);
export const getInvoiceOrdersEditAndSend = getInvoiceOrdersList(
  actionsEditAndSend.invoiceOrdersFetched,
  callTypesEditAndSend,
  requestFromServer.findInvoiceOrders(2)
);
export const getNextInvoiceOrdersEditAndSend = getInvoiceOrdersList(
  actionsEditAndSend.invoiceOrdersAppended,
  callTypesEditAndSend,
  requestFromServer.findInvoiceOrders(2)
);
